import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  inject,
  watch,
  computed,
} from "vue";
import gsap from "gsap";
import { PageTemplate } from "@/interfaces/PageTemplate";
export default defineComponent({
  props: {
    template: {
      type: Object as PropType<PageTemplate>,
      required: true,
    },
  },
  setup(props) {
    const pagewrapper = ref<HTMLElement | null>(null);
    const emitter = inject("emitter");

    onMounted(() => {
      const backgroundElements = pagewrapper.value?.querySelectorAll(
        ".pagewrapper__background"
      );

      if (window.innerWidth > 768) {
        const backgroundAnimation = gsap.to(backgroundElements as NodeList, {
          duration: 2,
          yPercent: -100,
          ease: "none",
          repeat: -1,
          force3D: true,
        });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        emitter.on("pagewrapper-background-animation--stop", (duration = 1) => {
          gsap.to(backgroundAnimation, {
            duration: duration,
            timeScale: 0,
            // ease: "elastic.out(1, 0.5)",
            ease: "power2.out",
            onComplete: function () {
              backgroundAnimation.pause();
            },
          });
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
        emitter.on(
          "pagewrapper-background-animation--start",
          (duration = 1) => {
            backgroundAnimation.play();
            gsap.to(backgroundAnimation, {
              duration: duration,
              timeScale: 1,
              overwrite: true,
              ease: "power2.in",
            });
          }
        );
      }
    });

    const templates = computed(() => {
      if (props.template === null) {
        return [];
      }

      return [props.template];
    });

    watch(templates, () => {
      window.scrollTo(0, 0);
    });

    return { pagewrapper, templates };
  },
});
